export default __webpack_public_path__ + "static/logoUnilever-4365d7124dcb5508cc7c4cc679e173a1.svg";